import { render, staticRenderFns } from "./rb-rox-prescription-preview.vue?vue&type=template&id=01392da8"
import script from "./rb-rox-prescription-preview.vue?vue&type=script&lang=js"
export * from "./rb-rox-prescription-preview.vue?vue&type=script&lang=js"
import style0 from "./rb-rox-prescription-preview.vue?vue&type=style&index=0&id=01392da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports